<template><div><h1 id="kauf-entwicklung" tabindex="-1"><a class="header-anchor" href="#kauf-entwicklung"><span>Kauf-Entwicklung</span></a></h1>
<p>Kauf-Entwicklung — Listet die Kauf-Enwicklung in einem bestimmten Zeitraum auf</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine HTML-Datei, welche die Entwicklung der Käufer aufzeigt. Als Käufer gelten Adressen mit Status &quot;K&quot; in einem bestimmten Jahr. Das Programm berücksichtigt also nur Umsätze aus Käufen, wobei die auszuwertenden Umsatztypen ausgewählt werden können. Es zeigt, welche Anzahl und Umsätze pro Jahr und pro Alter der Käufe erreicht wurden. Das Programm erstellt eine Tabelle mit Anzahl und eine Tabelle mit Umsatz, in der die Werte pro Jahr als Zeilen ausgegeben werden. Zur leichteren Übersicht können die Daten in einer Tabellenverarbeitung weiter bearbeitet werden.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Kauf-Entwicklung</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Jahr von</dt>
<dd>Muss-Eingabe: erstes Jahr der Auswertung (1. Spalte)</dd>
<dt>Jahr bis</dt>
<dd>Muss-Eingabe: letztes Jahr der Auswertung (1. Spalte)</dd>
<dt>Umsatztypen</dt>
<dd>Umsatztyp, mit Komma trennen, mit ! ausschliessen, * = alle</dd>
<dt>Ausgabe</dt>
<dd>HTML-Datei</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Jahr/Alter</td>
<td>Welches Jahr wird betrachtet? Einzelne Werte gemäss Parameter [Jahr von] und [bis]</td>
</tr>
<tr>
<td>0 Jahre</td>
<td>Aktuelle Käuferwerte (Anzahl oder Umsatz) im Jahr pro Zeile</td>
</tr>
<tr>
<td>1 Jahr</td>
<td>Käuferwerte derjenigen Käufer, die bereits im Vorjahr aktiv waren</td>
</tr>
<tr>
<td>2 Jahre</td>
<td>Käuferwerte derjenigen Käufer, die bereits 2 Jahre vorher aktiv waren</td>
</tr>
<tr>
<td>3 Jahre</td>
<td>analog oben</td>
</tr>
<tr>
<td>4 Jahre</td>
<td>analog oben</td>
</tr>
<tr>
<td>5 Jahre</td>
<td>analog oben</td>
</tr>
</tbody>
</table>
</div></template>


